import {Component, Input} from '@angular/core';
import {FileAttachmentApiService} from '@npck/af-frontend-api';
import {downloadFromBlobResponse, rxSpinner} from '@npck/libs/commons';
import {AttachmentViewModel} from '../../../pages/incidents/details/documents-tab/documents-tab.component';

@Component({
    selector: 'af-file-group-preview',
    templateUrl: './file-group-preview.component.html',
    styleUrl: './file-group-preview.component.scss',
    standalone: false,
})
export class FileGroupPreviewComponent {
    @Input() attachments: AttachmentViewModel[] = [];
    @Input() title?: string;
    @Input() showDownloadAll = false;
    @Input() spinnerId?: string;

    constructor(private fileAttachmentApiService: FileAttachmentApiService) {
    }

    downloadAll(): void {
        const fileIds = (this.attachments ?? []).flatMap(a => a.files.map(f => f.file.id));
        if (!fileIds.length) {
            return;
        }
        this.fileAttachmentApiService.downloadFiles(fileIds, 'response')
            .pipe(rxSpinner(this.spinnerId))
            .subscribe(response => downloadFromBlobResponse(response));
    }
}
